'use strict'

/* globals window:false, __resourceQuery:false, __webpack_public_path__:true */
/* eslint-disable camelcase */

function ensureSlash(str) {
  // eslint-disable-next-line prefer-template
  return str[str.length - 1] === '/' ? str : str + '/'
}

__webpack_public_path__ =
  typeof window !== 'undefined' &&
  window.zeus != null &&
  window.zeus.publicUrl != null
    ? ensureSlash(window.zeus.publicUrl)
    : '/'

if (
  process.env.NODE_ENV === 'development' &&
  typeof __resourceQuery === 'string' &&
  __resourceQuery
) {
  /* eslint-disable-next-line global-require  */
  const url = require('url')
  const clientUrlParts = url.parse(__webpack_public_path__)
  const ssrUrlParts = url.parse(__resourceQuery.substr(1))

  ssrUrlParts.path = clientUrlParts.path

  __webpack_public_path__ = url.format(ssrUrlParts)
}
